
<template>
	<c-dialog ref="dialog" title="选择产品" width="100vw-300" height="700" enable-flex @resolve="resolve">
	    <view-list work-type="7" view-id="10004" ref="view" selector :selected-field="{name: 'product_name'}">
	    	<template #search>
	    		<m-search ref="search" column="4" :init-data="initSearchData" :default-data="defaultSearchData" >
				    <m-search-item label="仓库">
					    <c-select name="warehouse_id" async @search="searchWarehouse" :value-data="warehouseOptions"></c-select>
				    </m-search-item>
					<m-search-item label="产品来源">
						<c-select :options="productSourceName" name="product_sources" multiple></c-select>
					</m-search-item>
					<m-search-item label="产品类型">
						<c-select :options="productTypeName" name="product_types" multiple></c-select>
					</m-search-item>
	    			<m-search-item label="产品编号">
	    				<c-input name="product_code"></c-input>
	    			</m-search-item>
	    			<m-search-item label="产品名称">
	    				<c-input name="product_name"></c-input>
	    			</m-search-item>
	    			<m-search-item label="产品规格">
	    				<c-input name="product_spec"></c-input>
	    			</m-search-item>
	    			<!-- <m-search-item label="工艺路线">
	    				<c-input name="route_name"></c-input>
	    			</m-search-item> -->
					<m-search-item label="工艺路线">
							<c-select name="route_ids" multiple async @search="searchRoute"></c-select>
						</m-search-item>
					<m-search-item>
						<c-checkbox-group name="is_product_bom">
							<c-checkbox value="1">仅查询已配置BOM的产品</c-checkbox>
						</c-checkbox-group>
					</m-search-item>
	    		</m-search>
	    	</template>
			
			<template #operate>
				<c-button color="main" v-if="auth('b_product_edit')" v-lock="lock('b_product_edit')" prepend-icon="tf-add" @click="globalDialog('productEdit', productEditHandle)">创建产品</c-button>
			</template>
	    
			<template #product_source="{data}">
				<c-state dict="productSourceName" :value="data.product_source"></c-state>
			</template>
		
	    	<template #product_type="{data}">
	    		<c-state dict="productTypeName" :value="data.product_type"></c-state>
	    	</template>
	    </view-list>
	</c-dialog>
</template>

<script>
	import {mapState} from 'vuex';

	export default {
	    name: 'productSelector',

		props: {
			warehouseOptions: Array,
			isProductBom: Boolean,
			initParam: Object
		},

		data() {
			return {
				initSearchData: this.initParam,
				defaultSearchData: {
					'is_product_bom': this.isProductBom ? [1] : []
				}
			}
		},
		
		computed: {
			...mapState(['productSourceName', 'productTypeName'])
		},
		
		methods: {
			open() {
				this.$refs.view.reset();
				this.$refs.dialog.open();
			},
			
			resolve(stop) {
				var data = this.$refs.view.selectedData;
				if (!data.length) {
					stop();
					this.$message({
						message: '请选择产品'
					});
					return;
				}
				this.$emit('resolve', data);
			},
			
			//创建产品后回调
			productEditHandle(data){
				this.$refs.view.update();
			},

			/*******搜索产品-工艺路线*****************/
			searchRoute(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'PROCESSROUTE_SEARCH',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			/*******搜索【仓库】下拉框信息*****************/
			searchWarehouse(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'WAREHOUSE',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			}
		}
	}
</script>